export interface ApplicationAPIConfig {
  teApiRoot: string
}

export interface ColaConfig {
  disabled?: boolean
  redirectUrl: string
}

export interface CognitoConfig {
  /** Fully-qualified domain of the hosted UI, *without* a trailing slash.
   *  e.g.  "https://eu-north-1abcd1234.auth.eu-north-1.amazoncognito.com"
   */
  domain: string;

  /** App-client ID shown in the Cognito console. */
  clientId: string;

  /** Exact callback URL that is registered in the App-client’s “Allowed callback URLs”. */
  redirectUri: string;

  /** Scopes requested in the Authorise URL (space-separated after encoding). */
  scopes: string[];          // typical: ['openid', 'email', 'phone']
}

export interface GraphqlUris {
  stagingUri: string;
  releaseUri: string;
}

export interface AuthUris {
  stagingUri: string;
  releaseUri: string;
}

export enum TargetEnvironment {
  Default = 'Default',
  Hero = 'Hero'
}

export interface LaunchDarklyConfig {
  clientId: string
}

export interface TmtLoggerConfig {
  application: string
  env: string
  graphqlUrl: string
  logLevel: number
  console: boolean
  debounceTime: number
}

export interface FlagsConfig {
	staging: string;
}

export interface ParamsConfig {
	oneTimeToken: string;
}


export interface ApplicationEnvironment {
  environmentName: string
  colaConfig: ColaConfig
  targetEnvironment: TargetEnvironment
  abstractionLayerConfig: GraphqlUris
  authLayerConfig: AuthUris
  launchDarklyConfig: LaunchDarklyConfig
  logConfig: TmtLoggerConfig | undefined
  flags: FlagsConfig
  params: ParamsConfig
}
